import { AnyAbility } from '@casl/ability';
import { AbilityProvider, Can as BaseCan, type CanProps } from '@casl/react';
import { createElement as h } from 'react';
import { useAppContext } from '~/App';

export const useAbilityContext = () => {
  const { ability } = useAppContext();
  return ability;
};

export const Can = (props: CanProps<AnyAbility>) => {
  const { ability } = useAppContext();

  return h(AbilityProvider, {
    value: ability,
    children: h(BaseCan, props),
  });
};
